import React from "react";
import { Link } from "react-router-dom";
import "../../../Assets/Scss/Admin.scss";
import { useEffect } from "react";
import { fetchAdminsUrl } from "../../../Library/URLs";
import axios from "axios";
import { useState } from "react";
import { useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import { CircularProgress } from "@mui/material";

const AdminTable = () => {
  const User = useSelector((state) => state.payroll?.User);
  //  const user_id = useSelector((state)=>state.admin.transaction_id)
  const [admins, setAdmins] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const unique_id = uuid();

  const FetchAllAdmins = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: User.company_id,
    };
    setIsLoading(true);
    await axios
      .post(fetchAdminsUrl, data)
      .then((res) => {
        setIsLoading(false);
        if (res.data) {
          setAdmins(res.data?.data);
        }
        // console.log('all department res',res.data)
      })
      .catch((err) => {
        // console.log('Get all department error',err.message)
        setIsLoading(false);
      });
  };

  useEffect(() => {
    FetchAllAdmins();
  }, []);
  return (
    <div className="Admin_Wrapper">
      <h2>Admins</h2>
      <div className="Top_Box">
        <h4>Companies registered on i4smart</h4>
        <Link className="Button" to="/create-admin">
          Add Admin
        </Link>
      </div>
      <div className="AdminTable">
        {isLoading && (
          <h3
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            loading.. <CircularProgress size={20} />
          </h3>
        )}
        {admins?.length === 0 && !isLoading && (
          <h3
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              width: "100%",
            }}
          >
            No recorded admin.
          </h3>
        )}
        {admins?.length > 0 && !isLoading && (
          <table>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
            </tr>
            {admins.map((admin, id) => (
              <tr key={id}>
                <td>{admin.first_name}</td>
                <td>{admin.last_name} </td>
                <td>{admin.email_address}</td>
              </tr>
            ))}
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminTable;
